export class WordleGame {

    constructor(){
        this.guesses = []
        //console.log("New game");
    }

}
